import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-raw-table',
  templateUrl: './raw-table.component.html',
  styleUrls: ['./raw-table.component.scss']
})
export class RawTableComponent implements OnInit {
  @Input() data;
  @Input() columns;
  @Input() route;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/home/raw-table/raw-table.component.ts